import { DefaultCellHeader, DefaultCenteredCellHeader } from "app/components/React/Table/headerCells";
import { CellSite, IndexCell, TrafficShareWithVisits } from "app/components/React/Table/cells";
import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberVisitsFilter, minVisits } from "app/filters/ngFilters";
import type { IInteraction } from "app/pages/segment-user-flow/buyer-journey/SegmentUserFlowContainer";
import { SEGMENT_MIN_VISITS_THRESHOLD } from "./Interactions";

export function minJourneyVisitsAbbrFilter() {
    return (val, threshold = SEGMENT_MIN_VISITS_THRESHOLD) =>
        minVisits(val, Number(threshold), abbrNumberVisitsFilter());
}

const SegmentUserFlowBucketTableColumnsConfig = (selectedInteraction: any) => [
    {
        displayName: "#",
        fixed: true,
        cellComponent: IndexCell,
        headerComponent: DefaultCenteredCellHeader,
        sortable: false,
        disableHeaderCellHover: true,
        width: 45,
        visible: true,
    },
    {
        field: "From",
        type: "string",
        format: "None",
        displayName: i18nFilter()(selectedInteraction.fromColumnDisplayTitle),
        headerComponent: selectedInteraction?.customTableHeaderColumnFrom
            ? selectedInteraction?.customTableHeaderColumnFrom
            : DefaultCellHeader,
        cellComponent: CellSite,
        minWidth: 350,
        sortable: true,
        isSorted: false,
        sortDirection: "desc",
        visible: true,
    },
    {
        field: "To",
        type: "string",
        format: "None",
        displayName: i18nFilter()(selectedInteraction.toColumnDisplayTitle),
        headerComponent: selectedInteraction?.customTableHeaderColumnTo
            ? selectedInteraction?.customTableHeaderColumnTo
            : DefaultCellHeader,
        cellComponent: CellSite,
        minWidth: 350,
        sortable: true,
        isSorted: false,
        sortDirection: "desc",
        visible: true,
    },
    {
        field: "Share",
        displayName: i18nFilter()("buyer.journey.bucket.table.columns.share"),
        sortable: true,
        isSorted: true,
        cellComponent: TrafficShareWithVisits,
        totalVisitsRowProp: "Visits",
        sortDirection: "desc",
        visible: true,
        shareMinThreshold: 500,
        totalVisitsFilter: minJourneyVisitsAbbrFilter,
        tooltip: i18nFilter()("buyer.journey.bucket.table.columns.tooltip.share"),
        maxWidth: 200,
    },
];

export const segmentUserFlowBucketTableColumnsConfigGen = (
    sortbyField: string,
    sortDirection: string,
    selectedInteraction: IInteraction,
) => {
    return SegmentUserFlowBucketTableColumnsConfig(selectedInteraction).map((col, idx) => {
        if (!col.sortable) {
            return col;
        }
        return {
            ...col,
            isSorted: col.field === sortbyField,
            sortDirection: col.field === sortbyField ? sortDirection : col.sortDirection,
        };
    });
};
